import { Link } from 'react-router-dom';

const CALCULATOR_URL = '/enciklopediya-korporativnogo-obucheniya/ocenka-effektivnosti-obucheniya#roi-calculator';

export default function RoiCtaStrip() {
  return (
    <section className="bg-teal-600">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 md:py-6 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3 text-white text-center md:text-left">
          <div className="hidden sm:flex w-11 h-11 bg-white/15 rounded-xl items-center justify-center flex-shrink-0">
            <i className="ri-calculator-line text-2xl text-white"></i>
          </div>
          <p className="text-base md:text-lg font-semibold leading-snug">
            Хотите узнать окупаемость обучения для вашей команды?
          </p>
        </div>
        <Link
          to={CALCULATOR_URL}
          className="w-full sm:w-auto bg-white text-teal-700 px-6 md:px-8 py-3.5 rounded-lg text-base font-bold hover:bg-teal-50 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2"
        >
          Посчитать ROI — калькулятор
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}